import { MODALS } from 'common/domain/constants';
class loansSignUpConfirmationModalController {
  constructor() {}

  get modal() {
    return $(MODALS.LOANS_CONFIRMATION_SIGN_UP);
  }
}

export default loansSignUpConfirmationModalController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpConfirmationModal/loansSignUpConfirmationModal.controller.js